/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

require('flatpickr');

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Choices from 'choices.js';
window.Choices = Choices;

import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi'

import { mainnet, arbitrum, bscTestnet, sepolia, bsc, zkFair } from 'viem/chains'

import {
  reconnect,
  watchAccount,
  signMessage,
  getAccount,
  disconnect,
  waitForTransactionReceipt,
  writeContract,
  http,
  createConfig
} from '@wagmi/core'

import { parseUnits } from 'viem'

const token_abi =  [
  {
    constant: false,
    inputs: [
      {
        name: "to",
        type: "address",
      },
      {
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
]

const tokenAddress = "0x87aeda878969075de0b4aab1e493bd2a22ee39dd"; // Test Token
const toAddress = "0x778c4f4ccd65A30A074441b9be6475f20de303d3"; // dev1

window.WalletConnect = {
	createWeb3Modal: createWeb3Modal,
	watchAccount: watchAccount,
	signMessage: signMessage,
	getAccount: getAccount,
  disconnect: disconnect,
  waitForTransactionReceipt: waitForTransactionReceipt,
  writeContract: writeContract,
  token_abi: token_abi,
  tokenAddress: tokenAddress,
  toAddress: toAddress,
  parseUnits: parseUnits,
  http: http,
	createConfig: createConfig,
  chains : {
    ETH: mainnet,
    bscTestnet: bscTestnet,
    BSC: bsc,
    ZKF: zkFair
  }
}

// 1. Define constants
const projectId = process.env.MIX_WALLET_CONNECT_PROJECT_ID

// 2. Create wagmiConfig
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: process.env.MIX_WALLET_APP_URL, // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [mainnet, arbitrum, bscTestnet]
window.WalletConnect.config = defaultWagmiConfig({
  chains, // required
  projectId, // required
  metadata, // required
  enableWalletConnect: true, // Optional - true by default
  enableInjected: true, // Optional - true by default
  enableEIP6963: true, // Optional - true by default
  enableCoinbase: true // Optional - true by default
  //...wagmiOptions // Optional - Override createConfig parameters
})
reconnect(window.WalletConnect.config)

// Xabier, añadir NOVA Wallet 22/11/2024 //
import { web3Enable, web3Accounts, web3FromAddress } from '@polkadot/extension-dapp';
window.web3Enable = web3Enable;
window.web3Accounts = web3Accounts;
window.web3FromAddress = web3FromAddress;
// Xabier, añadir NOVA Wallet //

// Xabier, añadir OkxWallet 05/12/2024 //
import {OKXUniversalProvider} from "@okxconnect/universal-provider";

window.okxUniversalProvider = await OKXUniversalProvider.init({
  dappMetaData: {
      name: "XKode",
      icon: "https://raw.githubusercontent.com/novasamatech/nova-utils/master/icons/dapps/dapps/color/xhype.png"
  },
})
// Xabier, añadir OkxWallet 05/12/2024 //